import { Event } from '../../types';
import { EventResponse } from 'generated/index';
import EventTooltipBody from './EventTooltipBody';

import {
  getAddressNotFound,
  getClientKeyArrangements,
  getClientName,
  getClientPhoneNumbers,
  getClientPlanningFeatures,
  getWarnings
} from '../../utils';

interface EventTooltipProps {
  event: Event | EventResponse;
  onMouseOver?: () => void;
  isStaticHTMLRender?: boolean;
}

const EventTooltip = (props: EventTooltipProps) => {
  const { event, onMouseOver, isStaticHTMLRender } = props;

  const {
    activity,
    absenceReason,
    clients,
    noteInternal,
    employees,
    employeeType,
    location,
    start,
    durationInSeconds,
    project,
    recurrenceRule,
    timeWindow,
    workPlace,
    createdOn,
    createdByName,
    lastUpdatedOn,
    lastUpdatedByName,
    warnings: {
      startsTooEarly = false,
      startsTooLate = false,
      hasOverlap = false,
      isOverQualified = false,
      isUnderQualified = false,
      excludedEmployeeClientCombination = false,
      excludedEmployeeClientCombinationDescription = '',
      isInSync = true
    } = {}
  } = event;

  const client = clients[0];
  const employee = employees?.[0];

  const clientName = getClientName(client);
  const clientNumber = client?.number;
  const phoneNumbers = getClientPhoneNumbers(client);
  const keyArrangments = getClientKeyArrangements(client);
  const planningFeatures = getClientPlanningFeatures(client);
  const addressNotFound = getAddressNotFound(location, activity);

  // let warnings be an empty array of strings
  const warningMessages: string[] = getWarnings(
    startsTooEarly,
    startsTooLate,
    hasOverlap,
    addressNotFound,
    isOverQualified,
    isUnderQualified,
    excludedEmployeeClientCombination,
    excludedEmployeeClientCombinationDescription,
    isInSync
  );

  return (
    <EventTooltipBody
      isStaticHTMLRender={isStaticHTMLRender}
      onMouseOver={onMouseOver}
      clientName={clientName}
      clientNumber={clientNumber}
      employeeName={employee?.nameInformal}
      start={start}
      durationInSeconds={durationInSeconds}
      timeWindow={timeWindow}
      locationType={location?.locationType}
      address={client?.address}
      activityName={activity?.name}
      project={project}
      workPlace={workPlace}
      recurrenceRule={recurrenceRule?.recurrenceRuleRepresentation}
      employeeTypeName={employeeType?.name}
      noteInternal={noteInternal}
      phoneNumbers={phoneNumbers}
      keyArrangements={keyArrangments}
      planningFeatures={planningFeatures}
      absenceReason={absenceReason}
      warnings={warningMessages}
      createdOn={createdOn}
      createdByName={createdByName}
      lastUpdatedOn={lastUpdatedOn}
      lastUpdatedByName={lastUpdatedByName}
    />
  );
};

export default EventTooltip;
